export const PRODUCT_NAME = 'Pediatric OT Complete Therapy System™';
export const PRODUCT_PRICE = 26.9;
export const CHECKOUT_URL = 'https://pediatric-ot-complete-therapy-system.impultienda.ar/checkout';
export const OFFER_ANCHOR = '#offer';
export const META_PIXEL_ID = '1822734912085445';
export const PRODUCT_IMAGE =
  'https://cdn.magicpatterns.com/uploads/mZJxGassjcumxMKRwmAhZQ/Sistema_integral_de_terapia_pediatrica_DIY.png';
export const SUPPORT_EMAIL = 'compradigitalyaa@gmail.com';

// Editable footer links — replace "#" with your real legal page URLs.
export const FOOTER_LINKS = [
  { label: 'Terms & Conditions', href: '#' },
  { label: 'Privacy Policy', href: '#' },
  { label: 'Contact', href: `mailto:${SUPPORT_EMAIL}` },
];

export const formatPrice = (value: number) => `$${value.toFixed(2)}`;
